

export function getIcon(notification) {
    switch (notification.customData?.eventType) {
        case "ABSENCE_REQUEST_SENT": return <i className="fa-regular fa-calendar-days"></i>
        case "ABSENCE_REQUEST_ACCEPTED": return <i className="fa-solid fa-circle-check text-success"></i>
        case "ABSENCE_REQUEST_DENIED": return <i className="fa-solid fa-circle-xmark text-danger"></i>
        case "ABSENCE_REQUEST_DELETED": return <i className="fa-solid fa-trash-can"></i>

        case "COST_REFUND_SENT": return <i className="fa-solid fa-receipt"></i>
        case "COST_REFUND_ACCEPTED": return <i className="fa-solid fa-circle-check text-success"></i>
        case "COST_REFUND_INCOMPLETE": return <i className="fa-solid fa-triangle-exclamation text-warning"></i>
        case "COST_REFUND_UPDATED": return <i className="fa-solid fa-arrows-rotate text-primary"></i>
        case "COST_REFUND_DELETED": return <i className="fa-solid fa-circle-xmark text-danger"></i>

        case "LOW_HR":
        case "HIGH_HR":
        case "HEALTH_AFIB": return <i className="fa-solid fa-heart-pulse"></i>
        case "HEALTH_MEASUREMENT": return <i className="fa-solid fa-flask"></i>

        case "LOW_CHARGE_ALERT": return <i className="fa-solid fa-battery-quarter"></i>
        case "OFF_BODY_ALERT": return <i className="fa-regular fa-hand-back-fist"></i>

        case "WHISTLE_SENT":
        case "ANONYMOUS_WHISTLE_SENT": return <i className="fa-solid fa-triangle-exclamation text-warning"></i>
        default: return <i className="fa-solid fa-bell"></i>
    }
}

export function renderTitle(notification, translation) {

    if (notification.customData != null) {
        switch (notification.customData.eventType) {
            case "ABSENCE_REQUEST_SENT": return translation("absenceReport:notification.absence.title.new_request_sent")
            case "ABSENCE_REQUEST_ACCEPTED":
            case "ABSENCE_REQUEST_DENIED":
            case "ABSENCE_REQUEST_DELETED": return translation("absenceReport:notification.absence.title.about_your_request")

            case "COST_REFUND_SENT": return translation("absenceReport:notification.costRefund.title.new_request_sent")
            case "COST_REFUND_UPDATED": return translation("absenceReport:notification.costRefund.title.request_adjusted")
            case "COST_REFUND_ACCEPTED":
            case "COST_REFUND_INCOMPLETE":
            case "COST_REFUND_DELETED": return translation("absenceReport:notification.costRefund.title.about_your_request")

            case "OVERTIME_REQUEST_ADDED": return translation("absenceReport:notification.overtime.title.overtime_added")

            case "WHISTLE_SENT":
            case "ANONYMOUS_WHISTLE_SENT": return translation("whistle:notification.title.new_warning_sent")

            default: return notification.title
        }
    } else return notification.title

}

export function renderContent(notification, translation) {
    if (notification.customData != null) {
        switch (notification.customData.eventType) {
            case "ABSENCE_REQUEST_SENT": return translation("absenceReport:notification.absence.content.new_request_sent", { agent: notification.customData.agentDisplayName })
            case "ABSENCE_REQUEST_ACCEPTED": return translation("absenceReport:notification.absence.content.request_accepted_by", { agent: notification.customData.agentDisplayName })
            case "ABSENCE_REQUEST_DENIED": return translation("absenceReport:notification.absence.content.request_denied_by", { agent: notification.customData.agentDisplayName })
            case "ABSENCE_REQUEST_DELETED": return translation("absenceReport:notification.absence.content.request_deleted_by", { agent: notification.customData.agentDisplayName })

            case "COST_REFUND_SENT": return translation("absenceReport:notification.costRefund.content.new_request_sent", { agent: notification.customData.agentDisplayName })
            case "COST_REFUND_UPDATED": return translation("absenceReport:notification.costRefund.content.request_updated_by", { agent: notification.customData.agentDisplayName })
            case "COST_REFUND_ACCEPTED": return translation("absenceReport:notification.costRefund.content.request_accepted_by", { agent: notification.customData.agentDisplayName })
            case "COST_REFUND_INCOMPLETE": return translation("absenceReport:notification.costRefund.content.request_marked_incomplete_by", { agent: notification.customData.agentDisplayName })
            case "COST_REFUND_DELETED": return translation("absenceReport:notification.costRefund.content.request_deleted_by", { agent: notification.customData.agentDisplayName })

            case "OVERTIME_REQUEST_ADDED": return translation("absenceReport:notification.overtime.content.overtime_added", { agent: notification.customData.agentDisplayName })

            case "WHISTLE_SENT": return translation("whistle:notification.content.new_warning_sent", { agent: notification.customData.agentDisplayName })
            case "ANONYMOUS_WHISTLE_SENT": return translation("whistle:notification.content.new_anonymous_warning_sent")
            default: return notification.body
        }
    } else return notification.body
}

export function getDestination(notification) {
    if (notification.customData != null) {


        switch (notification.customData.eventType) {
            case "ABSENCE_REQUEST_SENT_ACCEPTED":
            case "ABSENCE_REQUEST_SENT": return "/dashboard/absences/dashboard"
            case "ABSENCE_REQUEST_ACCEPTED":
            case "ABSENCE_REQUEST_DENIED":
            case "ABSENCE_REQUEST_DELETED": return "/dashboard/absences/my"

            case "COST_REFUND_SENT":
            case "COST_REFUND_UPDATED": return "/dashboard/costRefunds/detail"
            case "COST_REFUND_ACCEPTED":
            case "COST_REFUND_INCOMPLETE":
            case "COST_REFUND_DELETED": return "/dashboard/costRefunds/my/detail"

            case "OVERTIME_REQUEST_ADDED": return "/dashboard/overtimes/my"

            case "LOW_HR":
            case "HIGH_HR": return "/dashboard/health/dashboard"
            case "HEALTH_AFIB":
            case "HEALTH_MEASUREMENT":
                 return "/dashboard/health/events"

            case "LOW_CHARGE_ALERT":
            case "OFF_BODY_ALERT": return "/dashboard/devices/dashboard"

            case "WHISTLE_SENT":
            case "ANONYMOUS_WHISTLE_SENT": return "/dashboard/whistle/dashboard"
            default: return
        }
    } else return
}